import { z } from "zod";

const optional = () => z.string().optional().or(z.literal(""));

export const dispatchLineSchema = z.object({
  sales_order_line_id: z.string().min(1),
  sales_order_fulfillment_id: optional(),
  inventory_batch_id: z.string().min(1, "Batch required"),
  quantity: z.coerce.number().min(0),
  weight: z.coerce.number().min(0),
  notes: optional(),
  /** UI helpers */
  batch_no: optional(),
  material_name: optional(),
  line_no: z.coerce.number().optional(),
});

export const dispatchFormSchema = z
  .object({
    sales_order_id: z.string().min(1, "Sales order required"),
    client_id: z.string().min(1, "Client required"),
    invoice_id: optional(),
    dispatch_date: z.string().min(1, "Date required"),
    ship_to_text: optional(),
    notes: optional(),
    instructions: optional(),
    transporter_id: optional(),
    vehicle_id: optional(),
    driver_id: optional(),
    vehicle_number: optional(),
    transporter_name: optional(),
    driver_name: optional(),
    lr_number: optional(),
    lines: z.array(dispatchLineSchema).min(1, "Add at least one line"),
  })
  .superRefine((v, ctx) => {
    v.lines.forEach((line, i) => {
      if (line.weight <= 0 && line.quantity <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Enter qty or weight",
          path: ["lines", i, "weight"],
        });
      }
    });
  });

export type DispatchFormValues = z.infer<typeof dispatchFormSchema>;

export const emptyDispatchForm: DispatchFormValues = {
  sales_order_id: "",
  client_id: "",
  invoice_id: "",
  dispatch_date: new Date().toISOString().slice(0, 10),
  ship_to_text: "",
  notes: "",
  instructions: "",
  transporter_id: "",
  vehicle_id: "",
  driver_id: "",
  vehicle_number: "",
  transporter_name: "",
  driver_name: "",
  lr_number: "",
  lines: [],
};
